<template>
    <v-dialog
        v-model="$store.state.tracking.pendings"
        width="1360px"
        transition="dialog-transition"
    >
        <v-card height="600px">
            <v-toolbar color="primary" dense>
                <v-spacer></v-spacer>
                <v-toolbar-title class="white--text">Pendings</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    dark
                    @click="$store.state.tracking.pendings = false"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-row justify="center">
                    <v-col cols="4">
                        <v-row>
                            <v-col cols="6">
                                <v-combobox
                                    id="combox"
                                    dense
                                    v-model="shiftStart"
                                    :items="shiftDates"
                                    :item-text="'ShiftDate'"
                                    :item-value="'ShiftId'"
                                    label="Shift Start"
                                    hide-details
                                    aria-activedescendant="list-item-210-10"
                                ></v-combobox>
                            </v-col>
                            <v-col cols="6">
                                <v-combobox
                                    id="combox"
                                    dense
                                    v-model="shiftEnd"
                                    :items="shiftDates"
                                    :item-text="'ShiftDate'"
                                    :item-value="'ShiftId'"
                                    label="Shift End"
                                    hide-details
                                    aria-activedescendant="list-item-210-10"
                                ></v-combobox>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="3">
                        <v-radio-group
                            v-model="status"
                            row
                            hide-details
                            style="margin-top: 0px;"
                            dense
                            @change="loadPendingsStatus(status)"
                        >
                            <v-radio label="Pending " :value="1"></v-radio>
                            <v-radio
                                label="Finalized "
                                :value="0"
                            ></v-radio>
                            
                            <v-radio label="All " :value="2"></v-radio>
                        </v-radio-group>
                    </v-col>
                    <v-col cols="2">
                        <v-btn color="primary" @click="loadPendingsStatus(status)"  icon><v-icon>mdi-filter</v-icon></v-btn>
                        <v-btn color="primary" icon @click="pdf"
                            ><v-icon>mdi-file-pdf-box</v-icon></v-btn
                        >
                        <v-btn
                            color="primary"
                            class="float-right"
                            v-show="tgg"
                            icon
                            @click="tgg = false"
                            ><v-icon>mdi-plus-circle</v-icon></v-btn
                        >
                        <v-btn
                            color="primary"
                            class="float-right"
                            v-show="!tgg"
                            icon
                            @click="tgg = true"
                            ><v-icon>mdi-minus-circle-outline</v-icon></v-btn
                        >
                    </v-col>
                </v-row>
                <v-row justify="center" v-show="!tgg">
                    <v-col cols="2">
                        <v-combobox
                            id="combox"
                            class="mx-2"
                            dense
                            prepend-icon="mdi-calendar-refresh"
                            v-model="comboShiftDates"
                            :items="shiftDates"
                            :item-text="'ShiftDate'"
                            :item-value="'ShiftId'"
                            label="Shift Dates"
                            hide-details
                            aria-activedescendant="list-item-210-10"
                        ></v-combobox>
                    </v-col>
                    <v-col cols="10">
                        <v-row style="padding-top: 0px; margin: 0px;">
                            <v-text-field
                                name="Pending"
                                label="Pending"
                                v-model="pending"
                                hide-details
                                dense
                            ></v-text-field>
                            <v-btn color="Primary" icon @click="createPending"
                                ><v-icon>mdi-content-save</v-icon></v-btn
                            >
                        </v-row>
                    </v-col>
                </v-row>
                <v-row justify="center" v-show="respondShow" class="mb-5">
                    <v-col cols="12">
                        <v-simple-table dense>
                        <thead>
                            <tr>
                                <th width='10%'>Shift</th>
                                <th width='50%'>Pending</th>
                                <th width='25%'>Respond</th>
                                <th width='10%'>Save</th>
                                <th><v-btn color="primary" icon @click="respondShow = false;"><v-icon>mdi-arrow-up-drop-circle</v-icon></v-btn></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td><abbr :title="respond.TrackerCreate">{{ respond.Shift }}</abbr></td>
                                <td>
                                    <textarea rows="2" v-model="respond.Pending" style="width: 100%;border-style: none;"></textarea>
                                </td>
                                <td>     
                                    <textarea rows="2" v-model="respond.Respond" style="width: 100%;border-style: none;"></textarea>   
                                </td>
                                <td colspan="2">
                                    <v-btn color="primary" small @click="pendingConfirm(respond)">Finalize</v-btn>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                    </v-col>
                </v-row>
                <v-data-table
                    class="mt-1"
                    :headers="headers"
                    :items="items"
                    hide-default-footer 
                    dense
                    v-if="spinner"
                >
                <template v-slot:item.Shift="{ item }">
                    <abbr :title="item.TrackerCreate">{{ item.Shift }}</abbr>
                </template>
                <template v-slot:item.Pending="{ item }">
                    <textarea rows="2" v-model="item.Pending" style="width: 100%;border-style: none;"></textarea>
                </template>
                <template v-slot:item.Respond="{ item }">
                    <textarea rows="2" v-model="item.Respond" style="width: 100%;border-style: none;"></textarea>
                </template>
                <template v-slot:item.Active="{ item }">
                    <v-icon color="primary" v-if="item.Active == 1" @click="showRespondForm(item)">mdi-toggle-switch</v-icon>
                  <abbr :title="item.TrackerRespond" v-else><v-icon color="#999" >mdi-toggle-switch-off</v-icon></abbr>
                </template>
                </v-data-table>
                <v-row justify="center" class="mt-5" v-else>
                    <v-col cols="1">
                        <div class="sk-chase">
                                    <div class="sk-chase-dot"></div>
                                    <div class="sk-chase-dot"></div>
                                    <div class="sk-chase-dot"></div>
                                    <div class="sk-chase-dot"></div>
                                    <div class="sk-chase-dot"></div>
                                    <div class="sk-chase-dot"></div>
                                </div>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
        <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
    </v-dialog>
</template>
<script>
import axios from 'axios';
import moment from 'moment';
import ConfirmDialogue from './../../ConfirmDialogue.vue';
export default {
    props: ['shiftDates'],
    components: { ConfirmDialogue },
    data: function() {
        return {
            comboShiftDates: [],
            add: false,
            shiftStart:[],
            respond:{},
            spinner:true,
            shiftEnd: [],
            tgg: true,
            items: [],
            respondShow:false,
            status: 1,
            pending: null,
            headers: [
                { text: 'Shift', value: 'Shift', width: '10%' },
                { text: 'Pending', value: 'Pending', width: '50%' },
                { text: 'Respond', value: 'Respond', width: '25%' },
                { text: 'Status', value: 'Active', width: '5%' },
            ]
        };
    },
    mounted() {
        this.loadPendingsStatus(this.status);
    },
    methods: {
        showRespondForm: function(itm) {
            this.respond = itm;
            this.respondShow = true;
        },
        loadPendingsTrack: function() {
            var str = this.$store;
            axios
                .get('pendings', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.items = response.data;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        loadPendingsStatus: function(active) {
            var parms = {
                Active: active,
                Start: this.shiftStart.ShiftId,
                End: this.shiftEnd.ShiftId
            };
            this.spinner = false;
            console.log(parms);
            
            var str = this.$store;
            if(this.status == true) {
                this.searchStatus(parms);
            }else if(active == false && parms.Start == null || parms.End == null) {
                str.dispatch('setSnackbar', {
                    color: 'error',
                    text:'Select a date range'
                });
                
            this.spinner = true;
            }else{
                this.searchStatus(parms);
            }
        },
        searchStatus: function(parms){
            var str = this.$store;
            axios
                .post('pendings/status', parms,{
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.items = response.data;
            this.spinner = true;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                })
        },
        createPending: function(){
            var str = this.$store;
            var prms = {
                ShiftId: this.comboShiftDates.ShiftId,
                TrackerCreate:'',
                Active:true,
                Pending:this.pending,
                PendingDate: moment().format('YYYY-MM-DD')
            }
            axios
                .post('pendings',prms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response);
                    this.loadPendingsTrack();
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        async pendingConfirm(itm) {
            const ok = await this.$refs.confirmDialogue.show({
                title: 'You are ',
                message: 'Are you sure you want to finish this pending?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                this.UpdatgePending(itm);
            }
        },
        pdf: function(){
            var parms = {
                data: this.items,
                Active: this.status,
                Start: this.shiftStart.ShiftDate,
                End: this.shiftEnd.ShiftDate
            }
            axios
                .post('pendings/report', parms, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    var fileName = 'Pendings Tracking.pdf';
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName);
                    console.log(this.startDate);
                    document.body.appendChild(link);
                    link.click();
                    this.$store.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    this.$store.state.isLoading = false;
                });
        },
        UpdatgePending: function(itm){
            var str = this.$store;
            var prms = {
                TrackerRespond:'',
                Active:false,
                Respond:itm.Respond,
                PendingDate: moment().format('YYYY-MM-DD')
            }
            axios
                .put('pendings/'+itm.PendingID,prms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response);
                    this.loadPendingsTrack();
                    this.respondShow = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        }
    }
};
</script>
<style scoped>
td {
    padding: 5px !important;
}

.spinner {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 50px;
}

.sk-chase {
    width: 40px;
    height: 40px;
    position: relative;
    animation: sk-chase 2.5s infinite linear both;
}

.sk-chase-dot {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    animation: sk-chase-dot 2s infinite ease-in-out both;
}

.sk-chase-dot:before {
    content: '';
    display: block;
    width: 25%;
    height: 25%;
    background-color: #4f83cc;
    border-radius: 100%;
    animation: sk-chase-dot-before 2s infinite ease-in-out both;
}

.sk-chase-dot:nth-child(1) {
    animation-delay: -1.1s;
}
.sk-chase-dot:nth-child(2) {
    animation-delay: -1s;
}
.sk-chase-dot:nth-child(3) {
    animation-delay: -0.9s;
}
.sk-chase-dot:nth-child(4) {
    animation-delay: -0.8s;
}
.sk-chase-dot:nth-child(5) {
    animation-delay: -0.7s;
}
.sk-chase-dot:nth-child(6) {
    animation-delay: -0.6s;
}
.sk-chase-dot:nth-child(1):before {
    animation-delay: -1.1s;
}
.sk-chase-dot:nth-child(2):before {
    animation-delay: -1s;
}
.sk-chase-dot:nth-child(3):before {
    animation-delay: -0.9s;
}
.sk-chase-dot:nth-child(4):before {
    animation-delay: -0.8s;
}
.sk-chase-dot:nth-child(5):before {
    animation-delay: -0.7s;
}
.sk-chase-dot:nth-child(6):before {
    animation-delay: -0.6s;
}

@keyframes sk-chase {
    100% {
        transform: rotate(360deg);
    }
}

@keyframes sk-chase-dot {
    80%,
    100% {
        transform: rotate(360deg);
    }
}

@keyframes sk-chase-dot-before {
    50% {
        transform: scale(0.4);
    }
    100%,
    0% {
        transform: scale(1);
    }
}
</style>
